var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonriver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "#EBF1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3312 13.168C23.627 13.168 15.7663 21.0352 15.7598 30.7394C15.7598 31.8493 15.8636 32.9593 16.0713 34.0498L18.3432 32.4985C22.3352 29.7592 28.8069 29.7592 32.7924 32.4985L35.1746 34.1342L36.4664 35.0235C40.0624 37.4901 45.8914 37.4901 49.481 35.0235L50.5391 34.303C52.4864 24.7935 46.3588 15.5048 36.8493 13.5509C35.6939 13.3108 34.519 13.1939 33.3377 13.1939L33.3312 13.168Z",
    fill: "#F2B705"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2049 41.2937C40.6929 41.3391 38.2263 40.6381 36.1232 39.2814L32.4557 36.7694C28.3858 34.2703 23.2513 34.2703 19.1749 36.7694L16.8057 38.3921C16.3383 38.7167 15.6957 38.5934 15.3711 38.126C15.0466 37.6586 15.1699 37.016 15.6373 36.6915L18.0065 35.0687C22.784 32.1023 28.8337 32.1023 33.6111 35.0687L37.2786 37.5808C40.9071 39.8072 45.4833 39.8072 49.1118 37.5808L50.5009 36.6266C50.9683 36.302 51.6109 36.4253 51.9355 36.8927C52.26 37.3601 52.1367 38.0027 51.6693 38.3272L50.2802 39.2814C48.1771 40.6316 45.7105 41.3326 43.2049 41.2937Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7377 48.6717V38.7403C25.7312 38.5326 25.7377 38.3249 25.7637 38.1171C25.8286 37.5524 26.3089 37.124 26.8801 37.124C27.4319 37.1435 27.8798 37.5654 27.9317 38.1171C27.9771 38.4612 27.9836 38.8117 27.9706 39.1557V58.9536C27.9966 59.5962 27.4968 60.1285 26.8542 60.1544C26.8477 60.1544 26.8412 60.1544 26.8347 60.1544C26.2051 60.122 25.7247 59.5832 25.7572 58.9536C25.7572 58.9341 25.7572 58.9146 25.7637 58.9016V52.2937L25.7377 48.6717Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6535 43.6755V48.6087C23.6535 49.4526 23.1927 49.9978 22.563 49.9978C21.9399 49.9978 21.4401 49.4071 21.4336 48.6087V38.7358C21.4336 37.8724 21.9399 37.2882 22.5955 37.3467C23.2511 37.4051 23.6406 37.8984 23.6471 38.7682C23.6535 40.3845 23.6535 42.0268 23.6535 43.6755Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0596 43.67V40.2103C30.0596 39.4054 30.488 38.8861 31.1241 38.8861C31.7797 38.9186 32.2925 39.4768 32.2601 40.1324C32.2601 40.1454 32.2601 40.1649 32.2601 40.1778C32.2795 42.5341 32.2795 44.8904 32.2601 47.2531C32.2601 48.058 31.7992 48.5449 31.1306 48.5319C30.4685 48.5254 30.0661 48.0321 30.0596 47.2077V43.67Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1367 44.3816V40.9154C17.1367 40.1105 17.5651 39.5912 18.2013 39.5912C18.8569 39.6236 19.3697 40.1819 19.3372 40.8375C19.3372 40.8505 19.3372 40.8699 19.3372 40.8829C19.3567 43.2457 19.3567 45.6019 19.3372 47.9647C19.3372 48.7696 18.8763 49.2499 18.2142 49.2434C17.5586 49.237 17.1432 48.7436 17.1367 47.9193V44.3816Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4401 41.4366C36.0438 41.4366 36.5306 41.9234 36.5306 42.5271V44.4095C36.5306 45.0132 36.0438 45.5 35.4401 45.5C34.8364 45.5 34.3496 45.0132 34.3496 44.4095V42.5271C34.3561 41.9299 34.8429 41.4366 35.4401 41.4366Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7575 43.0922C40.3612 43.0922 40.848 43.579 40.848 44.1827V54.7567C40.848 55.3603 40.3612 55.8472 39.7575 55.8472C39.1538 55.8472 38.667 55.3603 38.667 54.7567V44.1827C38.667 43.579 39.1538 43.0922 39.7575 43.0922Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0505 43.4998C44.6541 43.4998 45.141 43.9866 45.141 44.5903V53.574C45.141 54.1777 44.6541 54.6645 44.0505 54.6645C43.4468 54.6645 42.96 54.1777 42.96 53.574V44.5903C42.96 43.9866 43.4468 43.4998 44.0505 43.4998Z",
    fill: "#53CBC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2229_701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 49,
    height: 50
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 12.3179H9.31641V61.0011H57.9996V12.3179Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2229_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3923 42.4761C48.9959 42.4761 49.4828 42.9629 49.4828 43.5666V47.4418C49.4828 48.0454 48.9959 48.5323 48.3923 48.5323C47.7886 48.5323 47.3018 48.0454 47.3018 47.4418V43.5666C47.3018 42.9629 47.7951 42.4761 48.3923 42.4761Z",
    fill: "#53CBC8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonriver);
export default __webpack_public_path__ + "static/media/Moonriver.936e393abc184f93c6d7a4f034440af9.svg";
export { ForwardRef as ReactComponent };